// Frontend version of quota defaults - keep in sync with backend/src/utils/quotaDefaults.ts
type UserSize = 'S' | 'M' | 'L';

export const PAGE_QUOTA_DEFAULTS: Record<UserSize, number> = {
  S: 1500,  // S-size users get 1500 pages
  M: 3500,  // M-size users get 3500 pages
  L: 7500  // L-size users get 7500 pages
}; 